module.exports = __webpack_public_path__ + "img/chilling_out_original.6654902.jpg";